export default __webpack_public_path__ + "static/media/ProductsList_img1_En.894ea788.webp";